import { render, staticRenderFns } from "./SettingsInfo.vue?vue&type=template&id=73f28ccb"
import script from "./SettingsInfo.vue?vue&type=script&lang=js"
export * from "./SettingsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports